// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

const ContractConfirmUpgradeController = function ($scope, $location, $routeParams, $http,
        gettext, gettextCatalog, ContractUpgradeChangesMediator, ProductInfo, PaymentMethod) {
    $scope.order = ContractUpgradeChangesMediator.order;
    $scope.currency = ContractUpgradeChangesMediator.currency;
    
    // There's nothing to confirm!
    if (!$scope.order.Id) {
        ContractUpgradeChangesMediator.reset();
        $location.path("/contracts/" + $routeParams.contractId + "/upgrade");
        return;
    }
    
    $scope.requirePayment = ContractUpgradeChangesMediator.requirePayment;
    $scope.datePresetName = ContractUpgradeChangesMediator.datePresetName;
    $scope.planChanged = ContractUpgradeChangesMediator.planChanged;
    
    $scope.isRecurringComponentsChanged = ContractUpgradeChangesMediator.recurringComponentUpdates.length !== 0;
    $scope.isDiscountChanged = ContractUpgradeChangesMediator.discountUpdates.length !== 0;
    $scope.isMeteredComponenetsChanged = ContractUpgradeChangesMediator.meteredComponentsUpdates.length !== 0;
    $scope.isRatedItemsChanged = ContractUpgradeChangesMediator.ratedItemsUpdates.length !== 0;

    $scope.unbilledActiveComponents = ContractUpgradeChangesMediator.recurringComponentUpdates.filter(function (component) { return component.IsActiveUnbilled && component.TotalGross !== 0; });
    $scope.addedComponents = ContractUpgradeChangesMediator.recurringComponentUpdates.filter(function (component) { return component.IsNewComponent; });
    $scope.canceledComponents = ContractUpgradeChangesMediator.recurringComponentUpdates.filter(function (component) { return component.IsCancellingNow; });
    $scope.endedComponents = ContractUpgradeChangesMediator.recurringComponentUpdates.filter(function (component) { return component.IsEndingNow; });

    $scope.addedDiscounts = ContractUpgradeChangesMediator.discountUpdates.filter(function (discount) { return discount.IsNewDiscount; });
    $scope.canceledDiscounts = ContractUpgradeChangesMediator.discountUpdates.filter(function (discount) { return discount.IsCancellingNow; });
    $scope.endedDiscounts = ContractUpgradeChangesMediator.discountUpdates.filter(function (discount) { return discount.IsEndingNow; });

    $scope.unbilledActiveMeteredComponents = ContractUpgradeChangesMediator.meteredComponentsUpdates.filter(function (component) { return component.IsActiveUnbilled; });
    $scope.addedMeteredComponents = ContractUpgradeChangesMediator.meteredComponentsUpdates.filter(function (component) { return component.IsNewMeteredUsage; });
    $scope.deletedMeteredComponents = ContractUpgradeChangesMediator.meteredComponentsUpdates.filter(function (component) { return component.IsDeletedNow; });
    
    $scope.addedRatedItems = ContractUpgradeChangesMediator.ratedItemsUpdates.filter(function (ratedItem) { return ratedItem.IsNewRatedItem || (ratedItem.IsActiveUnbilled && !ratedItem.IsDeletedNow); });

    $scope.deletedRatedItems = ContractUpgradeChangesMediator.ratedItemsUpdates.filter(function (component) { return component.IsDeletedNow; });

    $scope.trialMode = ContractUpgradeChangesMediator.trialMode;

    $scope.productInfo = ProductInfo.get(function () {
        $scope.priceListId = $scope.order.Cart.PriceListId !== undefined && $scope.order.Cart.PriceListId !== '' ? $scope.order.Cart.PriceListId : ContractUpgradeChangesMediator.priceListId;
    });

    setConfiguredOnAccountPaymentMethod();
    
    // Actions
    {
        $scope.back = function () {
            ContractUpgradeChangesMediator.isBack = true;
            $location.path("/contracts/" + $routeParams.contractId + "/upgrade");
        };
        $scope.cancel = function () {
            $scope.yesCancel(
                gettextCatalog.getString(gettext("Upgrade/Downgrade Contract")),
                gettextCatalog.getString(gettext("You are going to cancel the Up/Downgrade process")),
                function () {
                    // TODO: delete draft order

                    $location.path("/contracts/" + $routeParams.contractId);
                    ContractUpgradeChangesMediator.reset();
                }
            );
        };
        $scope.apply = function () {
            $http({
                method: "POST",
                url: "/api/v1/orders/" + $scope.order.Id + "/commit",
                params: null,
                data: {
                    PaymentMethod: (ContractUpgradeChangesMediator.onAccount ? $scope.availableOnAccountPaymentMethod : ""),
                    RequirePayment: $scope.requirePayment
                },
                headers: {},
                cache: false
            }).then(
                function (response) {
                    if (response.data.Status === "ApprovalPending") {
                        $location.path("/logs/orders/" + response.data.Id);
                    } else {
                        $location.path('/contracts/' + $routeParams.contractId);
                    }

                    ContractUpgradeChangesMediator.reset();
                });
        };

        $scope.$on("$destroy", function () {
            if (!ContractUpgradeChangesMediator.isBack) {
                ContractUpgradeChangesMediator.reset();
            }
        });
    }
    
    function setConfiguredOnAccountPaymentMethod() {
        PaymentMethod.query({}, function (data) {
            $scope.availableOnAccountPaymentMethod = "None:InvoicePayment";
            data.every(function (item) {
                if (item.Role.includes('OnAccount') || item.Provider.includes('OnAccount') || item.Provider.includes('InvoicePayment')) {
                    $scope.availableOnAccountPaymentMethod = item.Role + ":" + item.Provider;
                    return false;
                }
                return true;
            })
        });
    }
}

ContractConfirmUpgradeController.$inject = ['$scope', '$location', '$routeParams', '$http',
    'gettext', 'gettextCatalog', 'ContractUpgradeChangesMediator', 'ProductInfo', 'PaymentMethod'];
